"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UITable = _interopRequireDefault(require("UIComponents/table/UITable"));

var _ChecklistRow = _interopRequireDefault(require("../ChecklistRow"));

var _GradeTypeConstants = _interopRequireDefault(require("../../constants/GradeTypeConstants"));

var _MobileData = _interopRequireDefault(require("../../data/MobileData"));

var _PerformanceData = _interopRequireDefault(require("../../data/PerformanceData"));

var _SecurityData = _interopRequireDefault(require("../../data/SecurityData"));

var _SeoData = _interopRequireDefault(require("../../data/SeoData"));

var ChecklistRows = function ChecklistRows(_ref) {
  var websiteGrade = _ref.websiteGrade,
      resultsData = _ref.resultsData;

  var getGrade = function getGrade(result) {
    return websiteGrade.getIn(result.resultKeyPath, false);
  };

  var rows = resultsData.reduce(function (list, result, index) {
    result.init(getGrade(result));

    if (result.gradeType === _GradeTypeConstants.default.OK || result.gradeType === _GradeTypeConstants.default.BAD) {
      list.push(_react.default.createElement(_ChecklistRow.default, {
        key: index,
        result: result
      }));
    }

    return list;
  }, []);
  return rows;
};

var ChecklistTable = function ChecklistTable(_ref2) {
  var websiteGrade = _ref2.websiteGrade,
      resultsData = _ref2.resultsData,
      title = _ref2.title;

  if (websiteGrade.get('overallGrade') === 100) {
    return null;
  }

  return _react.default.createElement(_UITable.default, null, _react.default.createElement("colgroup", null, _react.default.createElement("col", {
    style: {
      width: '240px'
    }
  })), _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", null, title), _react.default.createElement("th", null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.checklist.headers.current"
  })), _react.default.createElement("th", {
    colSpan: "2"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.checklist.headers.recommendation"
  })))), _react.default.createElement("tbody", null, _react.default.createElement(ChecklistRows, {
    websiteGrade: websiteGrade,
    resultsData: resultsData
  })));
};

var _default = function _default(_ref3) {
  var websiteGrade = _ref3.websiteGrade;

  if (websiteGrade.get('overallGrade') === 100) {
    return null;
  }

  var showSEO = websiteGrade.getIn(['seoAudit', 'grade']) !== 30;
  var showSecurity = websiteGrade.getIn(['securityAudit', 'grade']) !== 10;
  var showPerformance = websiteGrade.getIn(['performanceAudit', 'grade']) !== 30;
  var showMobile = websiteGrade.getIn(['mobileAudit', 'grade']) !== 30;
  return _react.default.createElement("div", {
    className: "checklist-page"
  }, _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "wsg-container"
  }, _react.default.createElement("h3", null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.checklist.title"
  })), showPerformance && _react.default.createElement(ChecklistTable, {
    websiteGrade: websiteGrade,
    resultsData: _PerformanceData.default.topResults.concat(_PerformanceData.default.middleResults, _PerformanceData.default.bottomResults),
    title: _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "results.performance.title"
    })
  }), showSEO && _react.default.createElement(ChecklistTable, {
    websiteGrade: websiteGrade,
    resultsData: _SeoData.default.results,
    title: _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "results.seo.title"
    })
  }), showMobile && _react.default.createElement(ChecklistTable, {
    websiteGrade: websiteGrade,
    resultsData: _MobileData.default.results,
    title: _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "results.mobile.title"
    })
  }), showSecurity && _react.default.createElement(ChecklistTable, {
    websiteGrade: websiteGrade,
    resultsData: _SecurityData.default.results,
    title: _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "results.security.title"
    })
  }))));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/ChecklistPage.js
// module id = 259
// module chunks = 0